import styled from 'styled-components';
import React, { useEffect, useRef } from 'react';
import reactHtmlParser from 'react-html-parser';
import CountUp from 'react-countup';
import { devices } from '@/styles/theme/index.jsx';

const BlogSingle = ({ title, description, counter, desctextColor = "#fff", descfontSize="1.25rem", desclineHeight = "1.2", descletterSpacing="-0.03em", descfontWeight = "500", descmarGin = "0", textColor = "#7FB45A", fontSize="2.25rem", lineHeight = "1.2", letterSpacing="-0.03em", fontWeight = "600", marGin = "0 0 8px" }) => {
	const countUpStart = useRef(null);
	const containerRef = useRef(null);

	const textStyle = {
		fontWeight: fontWeight,
		fontSize:fontSize, // 64px (assuming 1rem = 20px)
		lineHeight: lineHeight, // 64px
		letterSpacing: letterSpacing, // -5%
		color: textColor,
		margin: marGin,
	};


	const DesctextStyle = {
		fontWeight: descfontWeight,
		fontSize:descfontSize, // 64px (assuming 1rem = 20px)
		lineHeight: desclineHeight, // 64px
		letterSpacing: descletterSpacing, // -5%
		color: desctextColor,
		margin: descmarGin,
	};

	// Setup intersection observer for main counter
	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					countUpStart.current?.start();
				}
			},
			{ threshold: 0.5 }
		);

		if (containerRef.current) {
			observer.observe(containerRef.current);
		}

		return () => observer.disconnect();
	}, []);

	return (
		<StyledListItemCounter className="counter">
			{counter === true ? (
				(() => {
					const [beforeCounter, afterCounter] = title.split(','); // splits into two parts
					return (
						<h5 className={'count-text fade-up'} style={textStyle} ref={containerRef}>
							<CountUp
								enableScrollSpy={true}
								start={0}
								end={beforeCounter}
								duration={2}
								separator=","
								decimals={0}
								decimal=","
							>
								{({ countUpRef: countRef, start }) => {
									countUpStart.current = { start };
									return <span ref={countRef} />;
								}}
							</CountUp>
							<div className="plus">{reactHtmlParser(afterCounter)}</div>
						</h5>
					);
				})()
			) : (
				<h5 className={'count-text fade-up'} style={textStyle}>
					{reactHtmlParser(title)}
				</h5>
			)}

			<p className="fade-up" style={DesctextStyle}>{reactHtmlParser(description)}</p>
		</StyledListItemCounter>
	);
};

const StyledListItemCounter = styled.div`
	h5{
		display: inline-flex;
		gap: 8px;
	}

    ${devices.sm} {
		p{
            font-weight: 500 !important;
            font-size: 1rem !important; /* 16px */
            line-height: 1.2 !important; /* 100% of font-size */
            letter-spacing: -0.03em !important;  /* -3% of the font-size */
		}
	}
`;
export default BlogSingle;
